import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { apiClient } from '@/http-client';
import { asDollars, getProvince } from '@/helpers/buildandquotehelpers';
import { getLanguageId } from '@helpers/language';
import { Button, Spinner } from '@components';
import styles from './PickerModal.module.scss';

export default function PickerModal({ show, onHide, productId, selectClicked }) {
  const router = useRouter();
  const { locale } = router;
  const [isLoaded, setIsLoaded] = useState(false);
  const [orderGroups, setOrderGroups] = useState(null);
  const [listPrice, setListPrice] = useState(null);
  const [configuration, setConfiguration] = useState(null);

  const handleClick = () => {
    // router.push(`/buildandquote/customize/${productId}?configuration=${configuration}`);
    const route = `/buildandquote/customize/${productId}?configuration=${configuration}`;
    window.location.replace(locale === 'fr' ? `/fr${route}` : `${route}`);
  };

  const langId = getLanguageId(locale);

  useEffect(() => {
    async function loadBuildAppNavigation(productId) {
      const province = getProvince('province') || 'ON';
      const { data } = await apiClient.get(`/api/Products/buildApp/${productId}/${province}?languageId=${langId}`);
      if (data?.OrderGroups) {
        setOrderGroups(data?.OrderGroups);
      }
      if (data?.mounts?.Parent) {
        setListPrice(data?.mounts?.Parent.ListPrice);
      }
      setIsLoaded(true);
    }

    loadBuildAppNavigation(productId);
  }, [productId]);

  return show ? (
    <div className={styles.pickerModal}>
      <div className={styles.header}>
        <div className={styles.title}>
          {locale == 'fr' ? 'Modèle de base' : 'Base Model Picker'}
        </div>
        <div className={styles.description}>
          {locale == 'fr' ? 'Veuillez sélectionner un forfait pour commencer' : 'Please select a package to get started'}
        </div>
        <div className={styles.close} onClick={onHide}>
          <FontAwesomeIcon icon={faTimes} flip="horizontal" />
        </div>
      </div>
      <div className={styles.list}>
        {!isLoaded ? (
          <Spinner />
        ) : (
          <>
            {orderGroups?.map((orderGroup) => (
              <div className={styles.pickerItem} key={orderGroup.Id}>
                <label onClick={() => setConfiguration(orderGroup.Id)}>
                  <input
                    type="radio"
                    name="OGDsp"
                  />
                  <div>
                    <span>{orderGroup.DescriptionEN}</span><br />
                    <b>{asDollars(locale, Number(orderGroup.ListPrice || listPrice))}</b>
                  </div>
                </label>
              </div>
            ))}
          </>
        )}
      </div>
      <div className={styles.actions}>
        <Button onClick={handleClick} disabled={!configuration}>
          {locale == 'fr' ? 'Personnaliser' : 'Customize'}
        </Button>
      </div>
    </div>
  ) : null;
}
